export const MAX_AD_PRODUCTS = 10;
